import React from "react";

import {
  Grid,
  useTheme,
  TextField,
  FormControl,
  InputAdornment,
} from "@mui/material";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const RpmBillingAmountInput = (props) => {
  const { index: rpmBillingItemIndex, rpmBillingItem, formikProps } = props;

  const { values, errors, touched, setFieldValue, setFieldTouched } =
    formikProps;

  const theme = useTheme();

  return (
    <div className="billing-amount__input-form">
      <Grid container rowSpacing={2}>
        <Grid item xs={3}>
          <div
            style={{
              fontSize: "12px",
              fontWeight: "500",
              color: theme.palette.type === "dark" ? "#C5C5C5" : "#757575",
            }}
          >
            BILLING CODE:
          </div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: theme.palette.type === "dark" ? "#F5F5F5" : "#444444",
            }}
          >
            {rpmBillingItem?.code}
          </div>
        </Grid>

        <Grid item xs={9}>
          <FormControl style={{ width: "100%" }}>
            <TextField
              id="rpmBilling-code"
              name={`rpmBilling[${rpmBillingItemIndex}].amount`}
              label="Billing Amount"
              variant="outlined"
              fullWidth
              required
              inputProps={{ maxLength: 6 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon />
                  </InputAdornment>
                ),
              }}
              error={
                touched.rpmBilling?.[rpmBillingItemIndex]?.amount &&
                !!errors.rpmBilling?.[rpmBillingItemIndex]?.amount
              }
              helperText={
                touched.rpmBilling?.[rpmBillingItemIndex]?.amount &&
                errors.rpmBilling?.[rpmBillingItemIndex]?.amount
              }
              style={{ width: "100%" }}
              defaultValue={values.rpmBilling?.[rpmBillingItemIndex]?.amount}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*)\./g, "$1")
                  .replace(/(\..{2}).*/g, "$1")
                  .replace(/^[0]+/g, "")
                  .replace(/^(\d*\.\d{2})\d+$/g, "$1");
              }}
              onChange={(e) => {
                const rpmBillingItemAmount = `rpmBilling[${rpmBillingItemIndex}].amount`;
                setFieldTouched(rpmBillingItemAmount);
                setFieldValue(rpmBillingItemAmount, e.target.value);
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
};

export default RpmBillingAmountInput;
